export default __webpack_public_path__ + "static/media/(18).856411d6.jpg";